// src/signals/vac-conversation-created-signal.ts
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { Signal } from "@shared-ui/core-signal-manager/spi";
var VacConversationCreatedSignal = /*#__PURE__*/ function(Signal) {
    "use strict";
    _inherits(VacConversationCreatedSignal, Signal);
    function VacConversationCreatedSignal() {
        _class_call_check(this, VacConversationCreatedSignal);
        return _call_super(this, VacConversationCreatedSignal, arguments);
    }
    return VacConversationCreatedSignal;
}(Signal);
// src/signals/vac-conversation-create-fail-signal.ts
import { Signal as Signal2 } from "@shared-ui/core-signal-manager/spi";
var VacConversationCreateFailedSignal = /*#__PURE__*/ function(Signal2) {
    "use strict";
    _inherits(VacConversationCreateFailedSignal, Signal2);
    function VacConversationCreateFailedSignal() {
        _class_call_check(this, VacConversationCreateFailedSignal);
        return _call_super(this, VacConversationCreateFailedSignal, arguments);
    }
    return VacConversationCreateFailedSignal;
}(Signal2);
// src/signals/vac-chat-window-visible-signal.ts
import { Signal as Signal3 } from "@shared-ui/core-signal-manager/spi";
var VacChatWindowVisibleSignal = /*#__PURE__*/ function(Signal3) {
    "use strict";
    _inherits(VacChatWindowVisibleSignal, Signal3);
    function VacChatWindowVisibleSignal() {
        _class_call_check(this, VacChatWindowVisibleSignal);
        return _call_super(this, VacChatWindowVisibleSignal, arguments);
    }
    return VacChatWindowVisibleSignal;
}(Signal3);
// src/signals/vac-chat-message-sent-signal.ts
import { Signal as Signal4 } from "@shared-ui/core-signal-manager/spi";
var VacChatMessageSentSignal = /*#__PURE__*/ function(Signal4) {
    "use strict";
    _inherits(VacChatMessageSentSignal, Signal4);
    function VacChatMessageSentSignal() {
        _class_call_check(this, VacChatMessageSentSignal);
        return _call_super(this, VacChatMessageSentSignal, arguments);
    }
    return VacChatMessageSentSignal;
}(Signal4);
// src/signals/vac-chat-message-send-failed-signal.ts
import { Signal as Signal5 } from "@shared-ui/core-signal-manager/spi";
var VacChatMessageSendFailedSignal = /*#__PURE__*/ function(Signal5) {
    "use strict";
    _inherits(VacChatMessageSendFailedSignal, Signal5);
    function VacChatMessageSendFailedSignal() {
        _class_call_check(this, VacChatMessageSendFailedSignal);
        return _call_super(this, VacChatMessageSendFailedSignal, arguments);
    }
    return VacChatMessageSendFailedSignal;
}(Signal5);
// src/signals/vac-initialization-error-signal.ts
import { Signal as Signal6 } from "@shared-ui/core-signal-manager/spi";
var VacInitializationErrorSignal = /*#__PURE__*/ function(Signal6) {
    "use strict";
    _inherits(VacInitializationErrorSignal, Signal6);
    function VacInitializationErrorSignal() {
        _class_call_check(this, VacInitializationErrorSignal);
        return _call_super(this, VacInitializationErrorSignal, arguments);
    }
    return VacInitializationErrorSignal;
}(Signal6);
// src/signals/vac-reconnect-signal.ts
import { Signal as Signal7 } from "@shared-ui/core-signal-manager/spi";
var VacReconnectSignal = /*#__PURE__*/ function(Signal7) {
    "use strict";
    _inherits(VacReconnectSignal, Signal7);
    function VacReconnectSignal() {
        _class_call_check(this, VacReconnectSignal);
        return _call_super(this, VacReconnectSignal, arguments);
    }
    return VacReconnectSignal;
}(Signal7);
// src/signals/vac-send-message-signal.ts
import { Signal as Signal8 } from "@shared-ui/core-signal-manager/spi";
var VacSendMessageSignal = /*#__PURE__*/ function(Signal8) {
    "use strict";
    _inherits(VacSendMessageSignal, Signal8);
    function VacSendMessageSignal() {
        _class_call_check(this, VacSendMessageSignal);
        return _call_super(this, VacSendMessageSignal, arguments);
    }
    return VacSendMessageSignal;
}(Signal8);
// src/signals/vac-notification-sound-signal.ts
import { Signal as Signal9 } from "@shared-ui/core-signal-manager/spi";
var VacNotificationSoundSignal = /*#__PURE__*/ function(Signal9) {
    "use strict";
    _inherits(VacNotificationSoundSignal, Signal9);
    function VacNotificationSoundSignal() {
        _class_call_check(this, VacNotificationSoundSignal);
        return _call_super(this, VacNotificationSoundSignal, arguments);
    }
    return VacNotificationSoundSignal;
}(Signal9);
// src/signals/vac-connected-signal.ts
import { Signal as Signal10 } from "@shared-ui/core-signal-manager/spi";
var VacConnectedSignal = /*#__PURE__*/ function(Signal10) {
    "use strict";
    _inherits(VacConnectedSignal, Signal10);
    function VacConnectedSignal() {
        _class_call_check(this, VacConnectedSignal);
        return _call_super(this, VacConnectedSignal, arguments);
    }
    return VacConnectedSignal;
}(Signal10);
// src/signals/vac-disconnected-signal.ts
import { Signal as Signal11 } from "@shared-ui/core-signal-manager/spi";
var VacDisconnectedSignal = /*#__PURE__*/ function(Signal11) {
    "use strict";
    _inherits(VacDisconnectedSignal, Signal11);
    function VacDisconnectedSignal() {
        _class_call_check(this, VacDisconnectedSignal);
        return _call_super(this, VacDisconnectedSignal, arguments);
    }
    return VacDisconnectedSignal;
}(Signal11);
// src/signals/vac-chat-message-received-signal.ts
import { Signal as Signal12 } from "@shared-ui/core-signal-manager/spi";
var VacChatMessageReceivedSignal = /*#__PURE__*/ function(Signal12) {
    "use strict";
    _inherits(VacChatMessageReceivedSignal, Signal12);
    function VacChatMessageReceivedSignal() {
        _class_call_check(this, VacChatMessageReceivedSignal);
        return _call_super(this, VacChatMessageReceivedSignal, arguments);
    }
    return VacChatMessageReceivedSignal;
}(Signal12);
// src/signals/vac-connect-websocket-signal.ts
import { Signal as Signal13 } from "@shared-ui/core-signal-manager/spi";
var VacConnectWebsocketSignal = /*#__PURE__*/ function(Signal13) {
    "use strict";
    _inherits(VacConnectWebsocketSignal, Signal13);
    function VacConnectWebsocketSignal() {
        _class_call_check(this, VacConnectWebsocketSignal);
        return _call_super(this, VacConnectWebsocketSignal, arguments);
    }
    return VacConnectWebsocketSignal;
}(Signal13);
// src/signals/vac-start-heartbeat-signal.ts
import { Signal as Signal14 } from "@shared-ui/core-signal-manager/spi";
var VacStartHeartbeatSignal = /*#__PURE__*/ function(Signal14) {
    "use strict";
    _inherits(VacStartHeartbeatSignal, Signal14);
    function VacStartHeartbeatSignal() {
        _class_call_check(this, VacStartHeartbeatSignal);
        return _call_super(this, VacStartHeartbeatSignal, arguments);
    }
    return VacStartHeartbeatSignal;
}(Signal14);
// src/signals/vac-dynamic-card-signal.ts
import { Signal as Signal15 } from "@shared-ui/core-signal-manager/spi";
var VacDynamicCardSignal = /*#__PURE__*/ function(Signal15) {
    "use strict";
    _inherits(VacDynamicCardSignal, Signal15);
    function VacDynamicCardSignal() {
        _class_call_check(this, VacDynamicCardSignal);
        return _call_super(this, VacDynamicCardSignal, arguments);
    }
    return VacDynamicCardSignal;
}(Signal15);
// src/signals/vac-fetch-history-messages-fail-signal.ts
import { Signal as Signal16 } from "@shared-ui/core-signal-manager/spi";
var VacFetchHistoryMessagesFailedSignal = /*#__PURE__*/ function(Signal16) {
    "use strict";
    _inherits(VacFetchHistoryMessagesFailedSignal, Signal16);
    function VacFetchHistoryMessagesFailedSignal() {
        _class_call_check(this, VacFetchHistoryMessagesFailedSignal);
        return _call_super(this, VacFetchHistoryMessagesFailedSignal, arguments);
    }
    return VacFetchHistoryMessagesFailedSignal;
}(Signal16);
// src/signals/vac-participant-events-signal.ts
import { Signal as Signal17 } from "@shared-ui/core-signal-manager/spi";
var VacParticipantEventsSignal = /*#__PURE__*/ function(Signal17) {
    "use strict";
    _inherits(VacParticipantEventsSignal, Signal17);
    function VacParticipantEventsSignal() {
        _class_call_check(this, VacParticipantEventsSignal);
        return _call_super(this, VacParticipantEventsSignal, arguments);
    }
    return VacParticipantEventsSignal;
}(Signal17);
// src/signals/vac-dynamic-card-webview-signal.ts
import { Signal as Signal18 } from "@shared-ui/core-signal-manager/spi";
var VacDynamicCardWebviewSignal = /*#__PURE__*/ function(Signal18) {
    "use strict";
    _inherits(VacDynamicCardWebviewSignal, Signal18);
    function VacDynamicCardWebviewSignal() {
        _class_call_check(this, VacDynamicCardWebviewSignal);
        return _call_super(this, VacDynamicCardWebviewSignal, arguments);
    }
    return VacDynamicCardWebviewSignal;
}(Signal18);
export { VacChatMessageReceivedSignal, VacChatMessageSendFailedSignal, VacChatMessageSentSignal, VacChatWindowVisibleSignal, VacConnectWebsocketSignal, VacConnectedSignal, VacConversationCreateFailedSignal, VacConversationCreatedSignal, VacDisconnectedSignal, VacDynamicCardSignal, VacDynamicCardWebviewSignal, VacFetchHistoryMessagesFailedSignal, VacInitializationErrorSignal, VacNotificationSoundSignal, VacParticipantEventsSignal, VacReconnectSignal, VacSendMessageSignal, VacStartHeartbeatSignal };
//# sourceMappingURL=index.js.map